<template>
	<div>
		<notification-message
			message="Aún no tienes notificaciones"
		/>
		<div class="main-content-container container-fluid px-4">
			<div class="page-header row no-gutters py-4">
				<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				  <span class="text-uppercase page-subtitle">Notificaciones</span>
				  <h3 class="page-title">Visión General</h3>
			  </div>
		  </div>
		</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage.vue'
	export default {
		components: {
			NotificationMessage
		}
	}
</script>